<template>
  <div>
    <v-row class="mb-6" no-gutters align="center">
      <v-btn
        :icon="$store.state.isMobile"
        :text="!$store.state.isMobile"
        color="indigo accent-3"
        v-on:click="goBack"
      >
        <v-icon :left="!$store.state.isMobile" size="20"
          >mdi-keyboard-backspace</v-icon
        >
        <span v-show="!$store.state.isMobile" style="font-size: 18px;"
          >Back</span
        >
      </v-btn>

      <h1
        v-if="id == 0 || typeof id == 'undefined'"
        class="color-services page-heading"
      >
        Add New Admin
      </h1>
      <h1 v-else class="color-services page-heading">Edit Admin</h1>
      <v-spacer />
      <v-btn
        v-if="(id == 0 || typeof id == 'undefined') && !$store.state.isMobile"
        text
        color="indigo accent-3"
        @click="validateAndSubmit"
        :loading="formSubmitLoading"
      >
        <span class="title">Submit</span>
      </v-btn>
      <v-btn
        v-else-if="!$store.state.isMobile"
        text
        color="indigo accent-3"
        @click="validateAndEdit"
        :loading="formSubmitLoading"
      >
        <span class="title">Save Changes</span>
      </v-btn>
    </v-row>

    <v-row
      justify="center"
      align="center"
      v-if="formLoading"
      style="height:50vh"
    >
      <v-progress-circular
        :size="70"
        color="#5c648b"
        indeterminate
      ></v-progress-circular>
    </v-row>

    <v-card v-if="!formLoading">
      <v-card-text>
        <v-form
          ref="adminForm"
          v-model="adminFormValid"
          lazy-validation
        >
          <v-row no-gutters>
            <v-col cols="12" sm="6" class="pa-4">
              <v-row no-gutters>
                <v-col md="4" xs="2">
                  <span class="lable-text">First Name</span>
                </v-col>
                <v-col xs="8">
                  <v-text-field
                    v-model="adminInfo.first_name"
                    placeholder="Enter first Name"
                    :rules="[rules.required]"
                    class="custom-bottom-line"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" class="pa-4">
              <v-row no-gutters>
                <v-col md="4" xs="2">
                  <span class="lable-text">Last Name</span>
                </v-col>
                <v-col xs="8">
                  <v-text-field
                    v-model="adminInfo.last_name"
                    placeholder="Enter last Name"
                    :rules="[rules.required]"
                    class="custom-bottom-line"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" class="pa-4">
              <v-row no-gutters>
                <v-col md="4" xs="2">
                  <span class="lable-text">Email</span>
                </v-col>
                <v-col xs="8">
                  <v-text-field
                    v-model="adminInfo.email"
                    placeholder="Enter Email"
                    type="email"
                    :rules="[rules.required]"
                    class="custom-bottom-line"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" class="pa-4">
              <v-row no-gutters>
                <v-col md="4" xs="2">
                  <span class="lable-text">Phone</span>
                </v-col>
                <v-col xs="8">
                  <v-text-field
                    v-model="adminInfo.mobile"
                    placeholder="Enter Phone"
                    type="number"
                    :rules="[rules.mobile]"
                    class="custom-bottom-line"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
            <!-- <v-col cols="12" sm="6" class="pa-4">
              <v-row no-gutters>
                <v-col md="4" xs="2">
                  <span class="lable-text">City</span>
                </v-col>
                <v-col xs="8"> -->
                  <!-- <v-text-field
                    v-model="adminInfo.city"
                    placeholder="Enter City"
                    :rules="[rules.required]"
                    class="custom-bottom-line"
                  ></v-text-field> -->
                  <!-- <v-text-field
                    v-if="(id !=0)"
                    v-model="adminInfo.city.name"
                    placeholder="Enter City"
                    :rules="[rules.required]"
                    class="custom-bottom-line"
                  ></v-text-field> -->

                  <!-- <v-autocomplete
                    v-model="adminInfo.city"
                    :items="computedCities"
                    :loading="isLoading"
                    :search-input.sync="search"
                    hide-no-data
                    hide-selected
                    item-text="cityName"
                    item-value="API"
                    placeholder="Start typing to Search"
                    return-object
                    class="custom-bottom-line"
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-row class="mt-2">
      <v-spacer />
      <v-btn
        v-if="(id == 0 || typeof id == 'undefined') && $store.state.isMobile"
        text
        color="indigo accent-3"
        @click="validateAndSubmit"
        :loading="formSubmitLoading"
      >
        <span class="title">Submit</span>
      </v-btn>
      <v-btn
        v-else-if="$store.state.isMobile"
        text
        color="indigo accent-3"
        @click="validateAndEdit"
        :loading="formSubmitLoading"
      >
        <span class="title">Save Changes</span>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "../../../../api/BaseAxios";
import { ROUTER_URL, API_ADMIN_URL } from "../../../../constants/urls";
import Keys from "../../../../constants/keys";

import store from "../../../../store";
import RULES from "../../../../common/fieldRules";

import MasterPermissionKeys from "../../../../constants/PermissionKeys";
import Helper from "../../../../helper";

export default {
  name: "AddAdmins",
  components: {},
  data() {
    return {
      router: ROUTER_URL,
      rules: RULES,
      formLoading: false,
      formSubmitLoading: false,
      adminFormValid: false,
      roleValid: false,
      id: 0,
      isLoading: false,
      cities: [],
      PermissionKeys: [],
      menu: false,
      roles_list: [],
      adminInfo: {
        first_name: "",
        last_name: "",
        mobile: "",
        email: "",
      },
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.PermissionKeys = MasterPermissionKeys;
  },
  computed: {
    ...mapGetters({
      permissions: "mainStore/getPermissions",
    }),
    computedCities() {
      return this.cities.map((entry) => {
        const cityName =
          entry.name +
          " - " +
          entry.country_details.name +
          "(" +
          entry.country_details.country_code +
          ")";
        return Object.assign({}, entry, { cityName });
      });
    },
  },
  watch: {
    permissions() {
    //  if (
    //    this.$route.name ===
    //      this.router.adminPanel.children.adminAdd.name &&
    //    this.permissions.indexOf(this.PermissionKeys.SERVICE_PROVIDER_ADD) < 0
    //  ) {
    //    this.$router.push({ name: "eblityLogin" });
    //  } else if (
    //    this.$route.name ===
    //      this.router.adminPanel.children.serviceProviderEdit.name &&
    //    this.permissions.indexOf(this.PermissionKeys.SERVICE_PROVIDER_EDIT) < 0
    //  ) {
    //    this.$router.push({ name: "eblityLogin" });
    //  }
    },
    search() {
      this.isLoading = true;

      this.getCityData();
    },
  },
  methods: {
    removeRole(item) {
      const index = this.roles.indexOf(item.id);
      if (index >= 0) this.roles.splice(index, 1);
    },
    className: (item) =>
      (item.grade_details ? item.grade_details.name + " - " : "") + item.name,

    getFormData() {
      var self = this;
      self.formLoading = true;
      const successHandler = (res) => {
        self.formLoading = false;
        self.roles_list = res.data.roles_list;
      };
      const failureHandler = (res) => {
        console.log(res);
      };
      Axios.request_GET(
        API_ADMIN_URL.adminAdd,
        {},
        {},
        successHandler,
        failureHandler,
        false
      );
    },

//    getCityData() {
//      var self = this;
//      self.isLoading = true;
//      // self.formLoading = true;
//      let params = {};
//      params["search_query"] = this.search;
//      const successHandler = (res) => {
//        self.isLoading = false;
//        self.cities = res.data.data;
//      };
//      const failureHandler = (res) => {
//        console.log(res);
//        self.isLoading = false;
//      };
//      Axios.request_POST(
//        API_ADMIN_URL.citySearch,
//        {},
//        {},
//        successHandler,
//        failureHandler,
//        false
//      );
//    },

  //  getAdminData() {
  //    var self = this;
//
  //    self.formLoading = true;
//
  //    const successHandler = (res) => {
  //      self.formLoading = false;
  //      self.adminInfo.first_name =
  //        res.data.data.user_details["first_name"];
  //      self.adminInfo.last_name =
  //        res.data.data.user_details["last_name"];
  //      self.adminInfo.mobile = res.data.data.user_details["mobile"];
  //      self.adminInfo.email = res.data.data.user_details["email"];
  //    };
//
  //    const failureHandler = (res) => {
  //      console.log(res);
  //    };
//
  //    let requestParams = {};
  //    requestParams[Keys.ID] = this.id;
//
  //    Axios.request_GET(
  //      API_ADMIN_URL.serviceProviderDetails,
  //      requestParams,
  //      {},
  //      successHandler,
  //      failureHandler,
  //      false
  //    );
  //  },
    validateAndSubmit() {
      var self = this;

      if (this.$refs.adminForm.validate()) {
        const successHandler = (res) => {
          store.dispatch("snackBar/showToast", {
            message: "New Admin Added",
            color: "S",
          });
          // self.goBack();
          self.$router.push({
            name: this.router.adminPanel.children.adminList.name,
            params: { id: res.data.id },
          });
          self.formSubmitLoading = false;
        };

        const failureHandler = (res) => {
          console.log(res);
          self.formSubmitLoading = false;
        };

        let requestParams = {};

        requestParams[Keys.EMAIL] = this.adminInfo.email;
        requestParams[Keys.MOBILE] = this.adminInfo.mobile;
        requestParams[Keys.FIRST_NAME] = this.adminInfo.first_name;
        requestParams[Keys.LAST_NAME] = this.adminInfo.last_name;

        self.formSubmitLoading = true;

        Axios.request_POST(
          API_ADMIN_URL.adminAdd,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      }
    },
    goBack() {
      Helper.goBack();
      // router.go(-1);
    },
//    validateAndEdit() {
//      var self = this;
//
//      if (this.$refs.adminForm.validate()) {
//        const successHandler = (res) => {
//          console.log(res.data.data);
//
//          // self.$store.state.studentDetails.studentData = res.data.data;
//          // self.$store.state.studentDetails.teamItems = res.data.data.team_list;
//          // self.$store.state.studentDetails.teamUserItems = [];
//          // res.data.data.team_list.forEach(element => {
//          //   if (element.status == "Active")
//          //     self.$store.state.studentDetails.teamUserItems.push(
//          //       element.team_member_details
//          //     );
//          // });
//
//          store.dispatch("snackBar/showToast", {
//            message: "Admin Edited",
//            color: "S",
//          });
//          self.formSubmitLoading = false;
//          self.goBack();
//        };
//
//        const failureHandler = (res) => {
//          console.log(res);
//          self.formSubmitLoading = false;
//        };
//
//        let requestParams = {};
//
//        requestParams[Keys.CITY] = this.adminInfo.city.id;
//        requestParams[Keys.EMAIL] = this.adminInfo.email;
//        requestParams[Keys.MOBILE] = this.adminInfo.mobile;
//        requestParams[Keys.FIRST_NAME] = this.adminInfo.first_name;
//        requestParams[Keys.LAST_NAME] = this.adminInfo.last_name;
//
//        self.formSubmitLoading = true;
//
//        console.log(requestParams);
//        // return 0;
//
//        Axios.request_PATCH(
//          API_ADMIN_URL.serviceProviderEdit,
//          requestParams,
//          {},
//          successHandler,
//          failureHandler,
//          false
//        );
//      }
//    },
  },
  mounted() {
//    this.getFormData();

//    if (this.id != 0 && typeof this.id != "undefined") {
//      this.getAdminData();
//    }
  },
};
</script>

<style>
.v-btn {
  text-transform: none;
}
</style>
